import React from "react";
import removeImg from "../../../assets/svgs/close.svg";
import { v4 } from "uuid";
import { Col, Row } from "react-bootstrap";

const AnalyticsArray = ({ items, setItems }) => {
  const handleInputOnChange = (e, id) => {
    const { name, value } = e.target;

    const newItemsArray = items.map((myItem) => {
      if (myItem.id !== id) return myItem;
      return { ...myItem, [name]: value };
    });

    setItems(newItemsArray);
  };

  const removeItem = (featureId) => {
    const newItems = items.filter((myItem, index) => myItem.id !== featureId);
    setItems(() => newItems);
  };

  const addItem = () => {
    setItems(() => [...items, { id: v4(), number: "", title: "" }]);
  };

  return (
    <div className="form-group branches features">
      <h5>
        العناصر
        {items?.length < 6 && (
          <button
            type="button"
            className="btn btn-green"
            onClick={() => {
              addItem();
            }}
          >
            إضافة عنصر
          </button>
        )}
      </h5>
      <Row>
        {items?.slice(0, 6)?.map((myItem, index) => {
          return (
            <Col xxl={4} lg={4} md={6} xs={12} key={index}>
              <div key={myItem.id} className="add-multi-component">
                <button
                  type="button"
                  onClick={() => removeItem(myItem.id)}
                  className="removeImg"
                >
                  <img src={removeImg} alt="" />
                </button>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group">
                      <h5>رقم العنصر</h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="رقم العنصر"
                        name="number"
                        onChange={(e) => handleInputOnChange(e, myItem.id)}
                        value={myItem?.number}
                      />
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group">
                      <h5>عنوان العنصر</h5>
                      <input
                        type="text"
                        className="form-control form-outline"
                        placeholder="عنوان العنصر"
                        name="title"
                        onChange={(e) => handleInputOnChange(e, myItem.id)}
                        value={myItem?.title}
                      />
                      <input type="hidden" value={v4()} />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default AnalyticsArray;
